import VueBaseController from '../vue_base'

export default class extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/public/work_report.vue') }

  static values = {
    shareToken: String,
    reportData: String
  }

  connect() {
    // Hide loading spinner
    const spinner = document.getElementById('loadingSpinner')
    if (spinner) {
      spinner.style.display = 'none'
    }
    
    // Mount Vue component
    super.connect({
      shareToken: this.shareTokenValue
    })
  }
}